import api from '@/api';
import { API_BASE_URL } from '..';
import {
  AuthorizationDownloadXmlRequestDTO,
  InvoiceSettingsData,
  QuotaFcpSettingsRequest,
  QuotaFcpSettingsResponse,
  StateCsrt,
} from './Settings.types';

const CONTROLLER_URL = `${API_BASE_URL}/settings`;

export async function createInvoiceSettings(obj: InvoiceSettingsData) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;
  return result as InvoiceSettingsData;
}

export async function updateInvoiceSettings(obj: InvoiceSettingsData) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;
  return result as InvoiceSettingsData;
}

export async function getInvoiceSettingsId(companyId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/company/${companyId}`,
    null,
  )) as unknown;

  return result as InvoiceSettingsData;
}

// AuthorizationDownloadXml

export async function createAuthorizationDownloadXml(
  obj: AuthorizationDownloadXmlRequestDTO,
): Promise<AuthorizationDownloadXmlRequestDTO> {
  const result = (await api.post(
    `${API_BASE_URL}/authorization-download-xml`,
    obj,
    null,
  )) as unknown;
  return result as AuthorizationDownloadXmlRequestDTO;
}

export async function listAuthorizationDownloadXml(id?: number) {
  const result = (await api.get(
    `${API_BASE_URL}/authorization-download-xml/invoice-settings/${id}`,
    null,
  )) as unknown;
  return result as AuthorizationDownloadXmlRequestDTO[];
}

export async function deleteAuthorizationDownloadXml(id: number) {
  const result = await api.remove(
    `${API_BASE_URL}/authorization-download-xml/${id}`,
    {},
    null,
  );

  return result;
}

export async function getAuthorizationDownloadXmlId(
  id: number,
): Promise<AuthorizationDownloadXmlRequestDTO> {
  const result = (await api.get(
    `${API_BASE_URL}/authorization-download-xml/${id}`,
    null,
  )) as unknown;
  return result as AuthorizationDownloadXmlRequestDTO;
}

export async function updateAuthorizationDownloadXml(
  obj: AuthorizationDownloadXmlRequestDTO,
  id: number,
): Promise<AuthorizationDownloadXmlRequestDTO> {
  const result = (await api.put(
    `${API_BASE_URL}/authorization-download-xml/${id}`,
    obj,
    null,
  )) as unknown;
  return result as AuthorizationDownloadXmlRequestDTO;
}

// Alíquota

export async function listQuotaFcpSettings(id: number) {
  const result = (await api.get(
    `${API_BASE_URL}/invoice-settings/${id}/quota_fcp_settings`,
    null,
  )) as unknown;

  return result as QuotaFcpSettingsResponse;
}

export async function createQuotaFcpSettings({
  obj,
  id,
}: {
  obj: QuotaFcpSettingsRequest;
  id: number;
}) {
  const result = (await api.post(
    `${API_BASE_URL}/invoice-settings/${id}/quota_fcp_settings`,
    obj,
    null,
  )) as unknown;

  return result as QuotaFcpSettingsResponse;
}

export async function updateQuotaFcpSettings({
  obj,
  id,
}: {
  obj: QuotaFcpSettingsRequest;
  id: number;
}) {
  const result = (await api.put(
    `${API_BASE_URL}/invoice-settings/${id}/quota_fcp_settings`,
    obj,
    null,
  )) as unknown;
  return result as QuotaFcpSettingsResponse;
}

export async function listStateCsrt(state: string) {
  const result = (await api.get(
    `${API_BASE_URL}/state-csrt/state/${state}`,
    null,
  )) as unknown;

  return result as StateCsrt[];
}
